import { loadSubscriptionInformation } from '../../apps/Billing/actions/BillingActionCreators';
import Settings from '../Settings';

async function loadSubscription(nextState) {
  if (!Settings.envFeatures.get('bigBank')) {

    console.log('Refreshing subscription information');
    const context = nextState.routes[0].getContext();
    await context.executeAction(loadSubscriptionInformation, {});

    console.log('Subscription information updated');

  }
  return {};
}

export default loadSubscription;



// WEBPACK FOOTER //
// ./src/utils/route/loadSubscription.js